module.exports = __webpack_public_path__ + "static/icons-intro-7d708dba7341429c174cc059d0c75537.svg";